import { CircularProgress } from "@mui/material";
import React from "react";
import styles from "./AppButton.module.css";

function AppButton({
  icon,
  height,
  loading,
  handleAction,
  width,
  fullwidth,
  btnText,
  textColor,
  btnBg,
}) {
  return (
    <button
      disabled={loading}
      onClick={handleAction}
      style={{
        height: height ? height : "46px",
        cursor: loading ? "not-allowed" : "pointer",
        width: fullwidth ? "100%" : width,
        color: textColor,
        backgroundColor: btnBg,
      }}
      className={styles.btn}
    >
      {icon && <img style={{ marginRight: 10 }} src={icon} alt="" />}
      {btnText}
      {loading && (
        <div className={styles.circular_progress}>
          <CircularProgress
            sx={{
              color: "white",
            }}
          />
        </div>
      )}
    </button>
  );
}

export default AppButton;
